import React from 'react';

import './translations/i18n';

import { errorToasts } from '@vlabs/uikit';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import { LunaError } from 'api-bindings/luna-client/LunaError';
import { initApp } from 'features/app/appSlice';

import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './store';

import './index.sass';
import 'styles/toasts.sass';

errorToasts.registerErrorHandlers(
  {
    condition: (e) => e instanceof LunaError,
    handler: (e) => errorToasts.showLunaErrorToast(e, 'Luna Streams API'),
  },
  errorToasts.axiosErrorHandler,
  errorToasts.defaultErrorHandler,
);

store.dispatch(initApp);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ToastContainer
          icon={false}
          position={toast.POSITION.TOP_LEFT}
        />
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
